import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import * as Sentry from "@sentry/angular";
import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HttpClient, provideHttpClient, withInterceptors} from "@angular/common/http";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {provideTranslateService, TranslateLoader, TranslateService} from '@ngx-translate/core';
import {DAMTranslationLoader} from './common/DAM-TranslationLoader';
import {authInterceptor} from './common/httpHelpers/auth.interceptor';
import {provideNativeDateAdapter} from "@angular/material/core";
import {MAT_ICON_DEFAULT_OPTIONS} from "@angular/material/icon";

const httpLoaderFactory: (http: HttpClient) => DAMTranslationLoader = (http: HttpClient) =>
    new DAMTranslationLoader(http);

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes, withComponentInputBinding()),
        provideAnimationsAsync(),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideTranslateService({
           //defaultLanguage: 'en-GB',
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }

        }),
        {
            provide: LOCALE_ID,
            useFactory: (translate: TranslateService) => {
                return translate.defaultLang;
            },
            deps: [TranslateService]
        },
        // {provide: LOCALE_ID, useValue: 'de'},
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
        provideNativeDateAdapter(),
        {provide: MAT_ICON_DEFAULT_OPTIONS, useValue: {fontSet: 'material-symbols-outlined'}},
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                // logErrors: true,
                showDialog: false
            })
        }
    ]
};

